import { Component, OnInit, Input, Output, EventEmitter, OnDestroy, SimpleChanges } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { MediasQueryService } from '../../services/medias-query.service';
import { Subscription } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { CustomDropdownMerchantsBottomComponent } from './bottom/custom-dropdown-merchants-bottom.component';

@Component({
  selector: 'app-custom-dropdown-merchants',
  templateUrl: './custom-dropdown-merchants.component.html'
})
export class CustomDropdownMerchantsComponent implements OnInit, OnDestroy {

  @Input() items: any[];
  @Input() display = 'name';
  @Input() selectedItem: any;
  @Input() partner: any;
  @Input() account: any;
  @Input() user;
  @Output() change = new EventEmitter<any>();
  @Output() settings = new EventEmitter<any>();

  model: any = {};
  mediasQuerySubscription: Subscription;

  constructor(
    private route: ActivatedRoute,
    private bottomSheet: MatBottomSheet,
    private mediasQueryService: MediasQueryService
  ) { }

  ngOnInit() {

    if (this.items)
      this.items.forEach(element => {
        if (element.configurations) {
          let obj = JSON.parse(element.configurations);
          element.color = obj.Frontend ? obj.Frontend.Color : '#000';
        }
        else
          element.color = '#000';
      });

    this.changeItem(this.selectedItem ?? this.items[0]);
    this.mediasQuerySubscription = this.mediasQueryService.isMobile().subscribe(result => this.model.isMobile = result);

    this.route.paramMap.subscribe(params => {
      this.model.partner = params.get('partner');
      this.model.account = params.get('account');
      this.model.merchant = params.get('merchant');
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes) {
      if (!changes.selectedItem.firstChange) {
        this.selectItem(changes.selectedItem?.currentValue);
      }
    }
  }

  changeItem(item: any) {
    this.selectItem(item);
    this.change.emit(item);
  }

  settingsItem(item: any) {
    this.selectItem(item);
    this.settings.emit(item);
  }

  selectItem(item) {
    this.selectedItem = item;
    this.model.open = false;
    this.firstLetter();
  }

  openItems() {
    if (this.model.isMobile) {

      const bottomRef = this.bottomSheet.open(CustomDropdownMerchantsBottomComponent, {
        data: {
          items: this.items,
          display: this.display,
          selectedItem: this.selectedItem,
          partner: this.model.partner,
          account: this.model.account,
          merchant: this.model.merchant
        }
      });

      bottomRef.afterDismissed().subscribe(result => {
        if (result) {
          if (result.redirectTo === 'transactions') {
            this.changeItem(result.item);
          } else {
            this.settingsItem(result.item);
          }
        }
      });
    }
    else {
      this.model.open = !this.model.open;
    }
  }

  firstLetter() {
    this.model.firstLetter = this.selectedItem ? this.selectedItem[this.display]?.charAt(0) : '';
  }

  ngOnDestroy() {
    this.mediasQuerySubscription.unsubscribe();
  }


}
